$(document).on('variant:change', function (event) {
    var variant = event.detail.variant;
    var variantTitle = variant.title.toLowerCase();
    if (variantTitle.includes('cacao')) {
        // $('.mrk-main-container').hide();
    }else{
        // $('.mrk-main-container').show();
    }
});